/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-redeclare */
import React, { useState, useEffect,useContext,useRef} from 'react'
import './chat.css'
import { Button } from '@material-ui/core'
import ReactScrollableFeed from 'react-scrollable-feed'
import convertTimestampToTime from './timeConvert/convertTimestampToTime'
import getGlobalVarContext from "../context/getGlobalVarContext";
import {useIntl} from 'react-intl';
import common from "../config/common.json";

function Chat({
  data,
  pubnub2
}) {
  // const [channels] = useState(['awesome-channel']);
  const [messages, addMessage] = useState([]);
  const [message, setMessage] = useState('');
  const [pubnub, setPubnub] = useState()
  const [onclick, setOnclick] = useState("")
  const [typingIndicater, setTypingindicater] = useState("")
  const {globalVar} = useContext(getGlobalVarContext());
  const {email}= globalVar
  const intl = useIntl()
  let messageInput = useRef(null)
  const timestamp = new Date().getTime()
  var msg_create_time = convertTimestampToTime(timestamp)
 
  function typingmsg() {
    var msg = { istyping: true, to: localStorage.getItem("name") }
    pubnub.signal({
      message: msg,
      channel: [data.group_name]
    }, (status, response) => {
      // console.log(response)
    });
  }
  const sendMessage = message => {
    var chatName = data?.chat_type === intl.formatMessage({id: "personalChat"}) ? intl.formatMessage({id: "personalChat"}) : intl.formatMessage({id: "groupChat"})
    const msg = {
      update: message,
      publisher: localStorage.getItem("email"),
      timestamp: new Date().getTime(),
      name: localStorage.getItem("name"),
      text: message,
      type: "text",
      chat: chatName
    }
    if (message) {
      pubnub
        .publish({ channel: data.group_name, message: msg, msg_create_time })
        .then(() => {
          setMessage('')
          updateUserTimestamp()
        });
    }
  };

  const updateUserTimestamp = async() => {
    var chatName = data?.chat_type === intl.formatMessage({id: "personalChat"}) ? intl.formatMessage({id: "personalChat"}) : intl.formatMessage({id: "groupChat"})
    let body = {
      timestamp: new Date().getTime() * 10000,
      chat_type: chatName,
      group_role:  chatName === "group" ? data.role : "user",
      userId: data.user_id,
      sub: localStorage.getItem("sub"),
      createdDate : data.created_date
    };
    let requestOptions = {
      method: "POST",
      body: JSON.stringify(body),
    };
    try {
      fetch(
        `${common.BASEURL}/user/update/timestamp`,requestOptions
      )
     } catch (error) {
      console.log(error);
    }
  };
  
  useEffect(() => {
    setPubnub(pubnub2)
    addMessage([])
    fetchHistory(data.group_name, pubnub2)
    messageInput.focus()
    // if(localStorage.getItem("openDrw") === "false"){
    //   var chaClassget = document.getElementById("chatmain");
    //   var mainChatget = document.getElementById("mainChatinput");
    //   chaClassget.style.flex = "0.6 1";
    //   mainChatget.style.width="55%";
    // }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])
  useEffect(() =>{
    setTimeout(() => {
      let pvtMsg = document.getElementById('chat_page_messages_history');
      pvtMsg.scrollTop = pvtMsg.scrollHeight;
    }, 10);
  },[message,messages])
  useEffect(() => {
    const listener = { // <-- extract the listener
      message: (message) => {
        if (message) {
          chatMessages(message)
        }

      },
      signal: function (event) {
        if (event.publisher !== localStorage.getItem("sub")) {
          if(event.channel === localStorage.getItem("channelName"))
          setTypingindicater(intl.formatMessage({id: "typingindicater" },{ name : event.message.to }))
          setTimeout(() => {
            setTypingindicater("")
          }, 3000)
        }

      },
    }
    pubnub2.addListener(listener); // <-- pass the listener here
    return function cleanup() {
      pubnub2.removeListener(listener); // <-- pass the same listener here
      pubnub2.unsubscribeAll();
      addMessage([]);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pubnub2]);
  function fetchHistory(channel1, pubnubObj) {
    pubnubObj.fetchMessages(
      {
        channels: [channel1],
        count: 100
      },
      (status, response) => {
        response?.channels?.[channel1].forEach((data) => {
          chatMessages(data)
        })
      }
    );
  }
  const chatMessages = (data) => {
    addMessage((messages) => [...messages, data]);
  }

  return (
    <div className='chatcontainer' id='chatmain'>
      <div className='header'>
        <div className='headerleft'>
          <h4><strong>{data.chat_type === intl.formatMessage({id: "personalChat"})? data.user_name : data.newgroup}</strong> </h4>
        </div>
        
      </div>
      <div className='chatmessage'>
        <div className='messagecontainer' id="chat_page_messages_history">
          {/* <ReactScrollableFeed> */}
            {messages.map((item, index) => {
              return (

                item.message?.publisher === localStorage.getItem("email") && localStorage.getItem("channelName") === item.channel ? (
                  <div className='receivemessage' key={`message-${index}`}>
                    {/* <Avatar  /> */}
                    <div className='messageinfo rightblue'>
                      <h4>{item.message?.chat === "personal" ? item.message?.name : item.message?.name} <span> {convertTimestampToTime(item.timetoken)} </span></h4>
                      <p className='message'>{item.message?.chat === "personal" ? item.message?.update : item.message?.update}</p>
                    </div>
                  </div>
                ) : 
                (
                localStorage.getItem("channelName") === item.channel &&
                  <div className='usersender' key={`message-${index}`}>
                    {/* <Avatar /> */}
                    <div className='messageinfo'>
                      <h4>{item.message?.chat === "personal"? item.message?.name : item.message?.name} <span> {convertTimestampToTime(item.timetoken)} </span></h4>
                      <p>{item.message?.chat === "personal" ? item.message?.update : item.message?.update}</p>
                    </div>
                  </div>                  
                )

              );
            })}
          {/* </ReactScrollableFeed> */}
        </div>


        <div className='chatinputcontainer' id='mainChatinput'>
        <div className='type'>
            <span>{typingIndicater}</span>
          </div>
        <form >
        <div style={{width:"90%"}}>
            <input
              id="chatInput"
              type="text"
              ref={(input) => { messageInput = input; }}
              placeholder="Type your message"
              value={message}
              onChange={e => {
                setMessage(e.target.value)
                typingmsg()
              }}
              style={{width:"95.3%",padding:"10px 12px"}}
            />
          </div>
          <div>
            <Button className="buttonSendmsg" type="submit"
              onClick={e => {
                e.preventDefault();
                setOnclick(message);
                sendMessage(message);
              }}
            >{intl.formatMessage({id: "buttonMsgSend" })}</Button>
          </div>
        </form>
      </div>
      </div>
    </div>
  )
}

export default Chat